import { Component, Input, OnDestroy } from '@angular/core';
import { ProductService } from '../../../services/product.service';
import { Product } from '../../../classes/product';
import { CartAuthGateService } from '../../../../core/services/cart-auth-gate.service';

@Component({
  selector: 'app-cart-modal',
  templateUrl: './cart-modal.component.html',
  styleUrls: ['./cart-modal.component.scss']
})
export class CartModalComponent implements OnDestroy {

  @Input() product: Product;
  @Input() currency: any;

  /** Conservado para la plantilla del modal (por si se reactiva). */
  public products: Product[] = [];

  constructor(
    private readonly productService: ProductService,
    private readonly cartAuthGate: CartAuthGateService
  ) {}

  goToCheckout(event: Event): void {
    event.preventDefault();
    this.cartAuthGate.proceedToCheckout();
  }

  /**
   * Agrega al carrito sin mostrar el modal de confirmación (Multikart).
   * La plantilla del modal se conserva por si se reactiva en el futuro.
   */
  openModal(product: Product): void {
    this.productService.addToCart(product);
  }

  ngOnDestroy(): void {
    // Sin modal activo; no requiere dismissAll.
  }
}
